$(document).ready(function () {

	var audioElement = document.createElement('audio');

  // media queries
  const mq = [
    window.matchMedia("(max-width: 767px)"),
    window.matchMedia("(min-width: 768px) and (max-width: 1279px)"),
    window.matchMedia("(min-width: 1280px)")
  ];


  // toggle sound_tracks to list or grid
  const
    soundMenuList = ".menu-list-js",
    soundMenuGrid = ".menu-grid-js",
    soundTracks = $(".sound-tracks-js");

  $(document).on("click", soundMenuList + ', ' + soundMenuGrid, function (e) {
    e.preventDefault();
  });

  if (soundTracks.length) {

    $(document).on("click", soundMenuList, function () {
      $(soundMenuGrid).removeClass("active");
      $(this).addClass("active");
      soundTracks.removeClass("sound_tracks--grid").addClass("sound_tracks--list");
    });

    $(document).on("click", soundMenuGrid, function () {
      $(soundMenuList).removeClass("active");
      $(this).addClass("active");
      soundTracks.removeClass("sound_tracks--list").addClass("sound_tracks--grid");
    });

  }


  // accordion
  if ($(".accordion").length) {
    const
      accordionLinks = $(".accordion-title-js"),
      accordionElements = $(".accordion-panels-js");

    $(accordionLinks).on("click", function (e) {
      if ($(this).hasClass("active")) {
        $(accordionLinks).filter('a[href="' + this.hash + '"]').removeClass("active");
        $(accordionElements).slideUp();
      } else {
        $(accordionLinks).removeClass("active").filter('a[href="' + this.hash + '"]').addClass("active");
        $(accordionElements).slideUp().filter(this.hash).addClass("open").slideDown(function () {
          if (mq[0].matches) {
            $("html, body").animate({
              scrollTop: $(this).prev().offset().top
            }, 1000);
          }
        });
      }
      e.preventDefault();
    });
  }
  
  // filters
  if ($(".filter_nav").length) {
    const
      filterLinks = $(".filter_nav__links"),
      filterElements = $(".filter_options");

    $(filterLinks).on("click", function (e) {
      if ($(this).hasClass("active")) {
        $(filterLinks).filter('a[href="' + this.hash + '"]').removeClass("active");
      } else {
        $(filterLinks).removeClass("active").filter('a[href="' + this.hash + '"]').addClass("active");
		$(filterElements).removeClass("open").filter(this.hash).addClass("open");
      }
      e.preventDefault();
    });
  }


  // sliders
  if ($.fn.slick) {
    $(".slider-songs-js").slick({
      variableWidth: true,
      autoplay: false,
      rows: 0,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="icon-arrow-left" aria-hidden="true"></i></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="icon-arrow-right" aria-hidden="true"></i></button>',
      responsive: [{
        breakpoint: 768,
        settings: {
          centerMode: true
        }
      }]
    });
    $(".slider-video-js").slick({
      variableWidth: true,
      autoplay: false,
      rows: 0,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="icon-arrow-left" aria-hidden="true"></i></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="icon-arrow-right" aria-hidden="true"></i></button>',
      responsive: [{
        breakpoint: 768,
        settings: {
          centerMode: true
        }
      }]
    });
  }


  // custom select
  if ($.fn.selectric) {
    $("select").selectric({
      maxHeight: 200,
      nativeOnMobile: false,
      arrowButtonMarkup: '<i aria-hidden="true" class="icon-arrow-down"></i>',
      responsive: true
    });
  }


  // range slider
  if ($.fn.ionRangeSlider) {
    $(".range-slider-js").ionRangeSlider();
  }


  // google maps
  if ($("#map-single-js").length && typeof address !== 'undefined') {
    const
      LatLng = new google.maps.LatLng(address[0][0], address[0][1]), // jshint ignore:line
      myOptions = {
        center: LatLng,
        scrollwheel: false,
        disableDefaultUI: false,
        zoom: 11
      };

    let marker;
    const map = new google.maps.Map(document.getElementById("map-single-js"), myOptions);
    marker = new google.maps.Marker({
      position: LatLng,
      map: map,
      icon: "/omeka/themes/dizi/asset/img/map-pin.png"
    });
  }

  if ($("#map-multi-js").length) {
    const ib = new InfoBox();
    let markers = [];

    const createMarker = function (site, map) {
      const
        siteLatLng = new google.maps.LatLng(site[0], site[1]),
        marker = new google.maps.Marker({
          position: siteLatLng,
          map: map,
          icon: "./img/map-pin.png",
          zIndex: site[2],
          html: site[3]
        }),
        boxText = document.createElement("div"),
        myOptions = {
          boxClass: "map_info_box",
          content: boxText,
          pixelOffset: new google.maps.Size(-101, 15),
          infoBoxClearance: new google.maps.Size(10, 10),
          closeBoxURL: "./img/close.png"
        };

      boxText.className = "holder";
      boxText.innerHTML = marker.html;

      markers.push(marker);

      google.maps.event.addListener(marker, "click", function () {
        ib.close();
        ib.setOptions(myOptions);
        ib.open(map, this);
        map.panTo(siteLatLng);
      });
    };

    const setMarkers = function (map, markers) {
      for (let i = 0; i < markers.length; i++) {
        createMarker(markers[i], map);
      }
    };

    const
      LatLng = new google.maps.LatLng(address[0][0], address[0][1]), // jshint ignore:line
      map = new google.maps.Map(document.getElementById("map-multi-js"), {
        center: LatLng,
        scrollwheel: false,
        disableDefaultUI: false,
        zoom: 11
      });

    google.maps.event.addListener(map, "click", function () {
      ib.close();
    });

    google.maps.event.addDomListener(window, "resize", function () {
      map.panTo(LatLng);
    });

    setMarkers(map, address); // jshint ignore:line
  }


  // table responsive
  $(".content table:not([class])").each(function () {
    while (this.attributes.length > 0) {
      this.removeAttribute(this.attributes[0].name);
    }
    $(this).wrapAll('<div class="table-responsive"></div>');
  });

	//play mp3
	$(document).on("click", '.sound_tracks__items .sound_tracks__play', function (e) {
		e.preventDefault();
		if($(this).hasClass('active')){
			if (!audioElement.paused) {
				audioElement.pause();
				$(this).find( "img" ).replaceWith('<img src="/omeka/themes/dizi/asset/img/play.svg?v=1.0.0" alt="">');
				$('.player_sticky .sound_tracks__play img' ).replaceWith('<img src="/omeka/themes/dizi/asset/img/play.svg?v=1.0.0" alt="">');
			} else {
				audioElement.play();
				$(this).find( "img" ).replaceWith('<img src="/omeka/themes/dizi/asset/img/pause.svg?v=1.0.0" alt="">');
				$('.player_sticky .sound_tracks__play img' ).replaceWith('<img src="/omeka/themes/dizi/asset/img/pause.svg?v=1.0.0" alt="">');
			}
		}else{
			if($(this).siblings('.sound_tracks__download').attr('href')!='#'){
				audioElement.setAttribute('src', $(this).siblings('.sound_tracks__download').attr('href'));
				audioElement.setAttribute('autoplay', 'autoplay');
				//audioElement.load()
				$.get();
				audioElement.addEventListener("load", function() {
				audioElement.play();
				}, true);
				audioElement.volume = .75;
			}
			if ($('.player_sticky').length) {
				$('.player_sticky').remove();
			}
			$(this).find( "img" ).replaceWith('<img src="/omeka/themes/dizi/asset/img/pause.svg?v=1.0.0" alt="">');
			$('.sound_tracks__items .sound_tracks__play.active img' ).replaceWith('<img src="/omeka/themes/dizi/asset/img/play.svg?v=1.0.0" alt="">');
			$('.sound_tracks__items .sound_tracks__play.active').removeClass('active');
			$('.sound_tracks__items.active').removeClass('active');
			$(this).addClass('active');
			$(this).closest('li').addClass('active');
			$(".body").append( '<div class="player_sticky">' +
				'<a href="#" class="sound_tracks__play" style="padding-left:25px;"><img src="/omeka/themes/dizi/asset/img/pause.svg?v=1.0.0" alt=""></a>' +
				'<div class="sound_tracks__text">' +
				$(this).siblings('.sound_tracks__text').html() +
			  '</div>' +
			  '<div class="time">0:00</div>'+
			  '<div class="playtime"><div class="timeline"><div class="progress"></div></div></div>' +
			  '<div class="volume"><div class="speaker -on"></div><div class="volume-slider"><div class="volume-percentage"></div></div></div>' +
			'<div class="headline_inner__buttons">' +
			  '<a href="#" class="btn btn--dark"><i aria-hidden="true" class="icon-share"></i>Dalintis</a>' +
			  '<a href="'+$(this).siblings('.sound_tracks__download').attr('href')+'" class="btn btn--deco" download><i aria-hidden="true" class="icon-download"></i>Atsisiųsti</a>' +
			'</div>' +
		  '</div>' );
		}
	});
	
	$(document).on("click", '.player_sticky .sound_tracks__play', function (e) {
		e.preventDefault();
		if(!audioElement.getAttribute('src')){
			audioElement.setAttribute('src', $(this).siblings('.headline_inner__buttons').find('.btn--deco').attr('href'));
			audioElement.setAttribute('autoplay', 'autoplay');
			//audioElement.load()
			$.get();
			audioElement.addEventListener("load", function() {
			audioElement.play();
			}, true);
			audioElement.volume = .75;
			$(this).find( "img" ).replaceWith('<img src="/omeka/themes/dizi/asset/img/pause.svg?v=1.0.0" alt="">');
		}else{
			if (!audioElement.paused) {
				audioElement.pause();
				$(this).find( "img" ).replaceWith('<img src="/omeka/themes/dizi/asset/img/play.svg?v=1.0.0" alt="">');
				$('.sound_tracks__play.active img' ).replaceWith('<img src="/omeka/themes/dizi/asset/img/play.svg?v=1.0.0" alt="">');
			} else {
				audioElement.play();
				$(this).find( "img" ).replaceWith('<img src="/omeka/themes/dizi/asset/img/pause.svg?v=1.0.0" alt="">');
				$('.sound_tracks__play.active img' ).replaceWith('<img src="/omeka/themes/dizi/asset/img/pause.svg?v=1.0.0" alt="">');
			}
		}
	});
	
	$(document).on("click", '.player_sticky .speaker', function (e) {
		audioElement.muted = !audioElement.muted;
		if (audioElement.muted) {
			$(this).removeClass(" -on");
			$(this).addClass(" -off");
		} else {
			$(this).removeClass(" -off");
			$(this).addClass(" -on");
		}
	});
	
	$(document).on("click", '.player_sticky .volume-slider', function (e) {
		const sliderWidth = window.getComputedStyle(this).width;
		const newVolume = e.offsetX / parseInt(sliderWidth);
		audioElement.volume = newVolume;
		$(".player_sticky .volume .volume-percentage").width(newVolume * 100 + '%');
	});
	
	$(document).on("click", '.player_sticky .timeline', function (e) {
		const timelineWidth = window.getComputedStyle(this).width;
		const timeToSeek = e.offsetX / parseInt(timelineWidth) * audioElement.duration;
		audioElement.currentTime = timeToSeek;
	});
	
	setInterval(() => {
		if (!audioElement.paused) {
		  const progressBar = $(".player_sticky .progress");
		  progressBar.width(audioElement.currentTime / audioElement.duration * 100 + "%");
		  $(".player_sticky .time").text(getTimeCodeFromNum(
			audioElement.currentTime
		  ));
		}
	}, 500);
	
	function getTimeCodeFromNum(num) {
	  let seconds = parseInt(num);
	  let minutes = parseInt(seconds / 60);
	  seconds -= minutes * 60;
	  const hours = parseInt(minutes / 60);
	  minutes -= hours * 60;

	  if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
	  return `${String(hours).padStart(2, 0)}:${minutes}:${String(
		seconds % 60
	  ).padStart(2, 0)}`;
	}
});
